import 'Services/Misc/Polyfills';
import { getInstance } from 'Services/State/StateManager';
import { getMeasurers } from 'Services/Measurement/MeasurerFactory';
import { getHostInterface, InterfaceTypes } from 'HostInterface/InterfaceFactory';
import { getConfigurationParser, ParserTypes } from 'Services/Parsers/ParserFactory';
import DisplayManager from 'Display/DisplayManager';
import MediaManager from 'Media/MediaManager';
import ReportingManager from 'Services/Reporting/ReportingManager';
import ViewabilityManager from 'Viewability/ViewabilityManager';
import 'Services/State/Updaters';

export default class VPAIDAd {
  constructor(window = {}) {
    this.HostInterface       = getHostInterface(InterfaceTypes.VPAID);
    this.Parser              = getConfigurationParser(ParserTypes.ACUITY);
    this.measurers           = getMeasurers(InterfaceTypes.VPAID);
    this.DisplayManager      = new DisplayManager();
    this.MediaManager        = new MediaManager();
    this.ReportingManager    = new ReportingManager();
    this.ViewabilityManager  = new ViewabilityManager();
    this.connectToHost(window);
    this.registerStateListeners();
  }

  connectToHost(window) {
    window.getVPAIDAd = () => this.HostInterface;
  }

  registerStateListeners() {
    this.listenables.forEach( l => getInstance().registerListener(l) );
  }

  // StateManager will call 'updateState' for each list item
  get listenables() {
    return [
      this.HostInterface,
      this.DisplayManager,
      this.MediaManager,
      this.Parser,
      this.ReportingManager,
      this.ViewabilityManager,
      ...this.measurers
    ]
  }
}

new VPAIDAd(window);


// WEBPACK FOOTER //
// ./src/VPAIDAd.js